import {
  type UseMutationOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/vue-query'
import { employeeNotificationById } from '../employeeNotificationEndpoints'
import {
  EMPLOYEE_NOTIFICATIONS_LATEST_QUERY_KEY,
  EMPLOYEE_NOTIFICATIONS_QUERY_KEY,
  EMPLOYEE_NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY,
} from '../employeeNotificationQueryKeys'
import { axiosInstance } from '@/modules/Core/plugins/axios'

export function deleteEmployeeNotification(id: number): Promise<void> {
  return axiosInstance
    .delete(employeeNotificationById(id))
    .then(() => undefined)
}

export function useDeleteEmployeeNotificationMutation(
  options?: UseMutationOptions<void, AxiosCustomError, number>
) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteEmployeeNotification,
    ...options,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [EMPLOYEE_NOTIFICATIONS_QUERY_KEY],
      })
      queryClient.invalidateQueries({
        queryKey: [EMPLOYEE_NOTIFICATIONS_LATEST_QUERY_KEY],
      })
      queryClient.invalidateQueries({
        queryKey: [EMPLOYEE_NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY],
      })
    },
  })
}
